export interface Colors {
  proSteelGrey400: string
  proSteelGrey600: string
  proSteelGrey700: string
  proBlue400: string
}

const COLORS: Colors = {
  proSteelGrey400: '#ABB8C5',
  proSteelGrey600: '#546372',
  proSteelGrey700: '#2A353F',
  proBlue400: '#4B7FD5'
}

export interface OtherRatingTypes {
  service_rating: string
  price_rating: string
  quality_rating: string
  timeliness_rating: string
}

const OTHER_RATING_TYPES: OtherRatingTypes = {
  service_rating: 'Customer Service',
  price_rating: 'Pricing/Value',
  quality_rating: 'Quality',
  timeliness_rating: 'Timeliness'
}

export interface RatingTypes extends OtherRatingTypes {
  overall_rating: string
}

const RATING_TYPES: RatingTypes = {
  ...OTHER_RATING_TYPES,
  overall_rating: 'Overall'
}

const Const = {
  COLORS,
  RATING_TYPES,
  OTHER_RATING_TYPES
}

export default Const
